import { CSSProperties, ReactNode, RefObject } from "react";

import { confirmPopup, ConfirmPopupProps } from "primereact/confirmpopup";
import { IconType } from "primereact/utils";

import { translationKeys } from "../../../models/app-translation-keys";

interface IConfirmActionPopupProps {
  target: RefObject<any>;
  message?: string;
  messageNode?: ReactNode;
  acceptLabel?: string;
  rejectLabel?: string;
  acceptClassName?: string;
  rejectClassName?: string;
  acceptIcon?: IconType<ConfirmPopupProps>;
  rejectIcon?: IconType<ConfirmPopupProps>;
  icon?: IconType<ConfirmPopupProps>;
  defaultFocus?: "accept" | "reject";
  style?: CSSProperties;
  acceptAction: () => void;
}

export const confirmActionPopup = async (
  translationFunction: (key: string) => string,
  props?: IConfirmActionPopupProps,
): Promise<boolean> => {
  return new Promise((resolve, _reject) => {
    confirmPopup({
      target: props?.target?.current,
      message: props?.messageNode || props?.message || translationFunction(translationKeys.dialog.confirm.message),
      icon: props?.icon,
      defaultFocus: "reject",
      acceptClassName: props?.acceptClassName ?? "p-button-danger",
      rejectClassName: props?.rejectClassName,
      acceptLabel: props?.acceptLabel || translationFunction(translationKeys.dialog.confirm.acceptLabel),
      rejectLabel: props?.rejectLabel || translationFunction(translationKeys.dialog.confirm.rejectLabel),
      acceptIcon: props?.acceptIcon,
      rejectIcon: props?.rejectIcon,
      accept: () => {
        props?.acceptAction();
        resolve(true);
      },
      reject: () => resolve(false),
      style: props?.style,
    });
  });
};
